import React from "react";
import AccordianCard from "../../../../../../accordion-card/accordian-card";
import "../../../pitch-deck-analysis.css";
import PitchDeckDetails from "../../view-details/details-component";
import PitchDeckTableView from "../../pitch-deck-table-view/pitch-deck-table-view";
import PitchDeckContentLayout from "../../../../../../../layout/pitch-deck-analysis-page/pitch-deck-content-layout";

function ViewOperations({ data }) {
  return (
    <PitchDeckContentLayout data={data} type="operations">
      <AccordianCard
        className="companyaccordion"
        title="Traction"
        activeKey="traction"
      >
        <PitchDeckDetails
          data={data}
          detailsArray={[
            {
              displayName: `What is your traction (KPI metrics)?`,
              fieldName: "kpiMetrics",
              type: "bullets",
            },
            {
              displayName: `What are the traction metrics that show what you have
                    achieved so far?`,
              fieldName: "metricsThatShowAchievement",
              type: "bullets",
            },
            {
              displayName: `What are the week-over-week or month-over-month growth rate?`,
              fieldName: "growthRate",
              type: "bullets",
            },
            {
              displayName: `Is there proof of latent demand?`,
              fieldName: "proofOfLatentDemand",
              type: "bullets",
            },
            {
              displayName: `Is your business growing?`,
              fieldName: "isBusinessGrowing",
              type: "bullets",
            },
            {
              displayName: `Is your product-or-service self-perpetuating its growth?`,
              fieldName: "isProductSelfPerpetuatingGrowth",
              type: "bullets",
            },
            {
              displayName: `Have you been able to accomplish with less money in less
                    time?`,
              fieldName: "ableToAccomplishWithLess",
              type: "bullets",
            },
          ]}
        />

        <PitchDeckTableView
          data={data}
          rowArray={[
            {
              type: "bodyHeaderCenter",
              displayName: "PRODUCT-MARKET FIT",
            },
            {
              fieldName: "percentCustWillBeDisappointed",
              displayName: `Percentage of surveyed customers who indicate "much disappointment" if they no longer have access to your product`,
              displayUnit: "%",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "BOUNCE RATE",
            },
            {
              fieldName: "bounceRate",
              displayName:
                "Percentage of visitors to your website who navigate away after viewing only one page",
              displayUnit: "%",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "TIME ON SITE",
            },
            {
              fieldName: "timeOnSite",
              displayName: "Time visitors spent on your website",
              displayUnit: "seconds",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "PAGES PER VISIT",
            },
            {
              fieldName: "numPageViews",
              displayName: "Total no. of page views",
              displayUnit: "views",
            },
            {
              fieldName: "numSessions",
              displayName: "Total no. of sessions",
              displayUnit: "sessions",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "RETURNING VISITORS RATE",
            },
            {
              fieldName: "numRepeatVisitors",
              displayName:
                "No. of repeat visitors to your site in a specific time period",
              displayUnit: "visitors",
            },
            {
              fieldName: "totalNumUniqueVisitors",
              displayName:
                "Total no. of unique visitors to your site in a specific time period",
              displayUnit: "visitors",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "SOCIAL MEDIA ENGAGEMENT RATE",
            },
            {
              fieldName: "totalNumEngagements",
              displayName: "Total no. of engagements",
              displayUnit: "engagements",
            },
            {
              fieldName: "totalNumFollowers",
              displayName: "Total no. of followers",
              displayUnit: "followers",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "MARKETING RETURN ON INVESTMENT (ROI)",
            },
            {
              fieldName: "netSalesPriorPeriod",
              displayName: "Net sales for the prior period",
              renderContent: !data["netSalesPriorPeriod"]
                ? "-"
                : "USD" + data["netSalesPriorPeriod"],
            },
            {
              fieldName: "netSalesCurrentPeriod",
              displayName: "Net sales for the current period",
              renderContent: !data["netSalesCurrentPeriod"]
                ? "-"
                : "USD" + data["netSalesCurrentPeriod"],
            },
            {
              fieldName: "marketingCost",
              displayName: "Cost of marketing",
              renderContent: !data["marketingCost"]
                ? "-"
                : "USD" + data["marketingCost"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "ACTIVE USERS",
            },
            {
              fieldName: "numDailyActiveUsers",
              displayName: "No. of daily active users",
              displayUnit: "users",
            },
            {
              fieldName: "numMonthlyActiveUsers",
              displayName: "No. of monthly active users",
              displayUnit: "users",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "CUSTOMER ACQUISITION COST (CAC)",
            },
            {
              fieldName: "custAcquisitionCost",
              displayName:
                "Amount of money your company spends to get a new customer",
              renderContent: !data["custAcquisitionCost"]
                ? "-"
                : "USD" + data["custAcquisitionCost"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "QUALIFIED LEADS",
            },
            {
              fieldName: "numQualifiedLeads",
              displayName: "No. of qualified leads",
              displayUnit: "leads",
            },
            {
              fieldName: "numPotentialCustomers",
              displayName: "No. of potential customers",
              displayUnit: "customers",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "TIME ON PAGE",
            },
            {
              fieldName: "timeOnPage",
              displayName:
                "Time user spent on a particular page on your website",
              displayUnit: "seconds",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "CONVERSION RATE",
            },
            {
              fieldName: "numConvertedUsers",
              displayName: "No. of converted users",
              displayUnit: "users",
            },
            {
              fieldName: "audienceSize",
              displayName: "Size of audience",
              renderContent: !data["audienceSize"] ? "-" : data["audienceSize"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "USER RETENTION",
            },
            {
              fieldName: "numUsersOfProductOnSpecificDay",
              displayName:
                "No. of users who used your product on a specific day",
              displayUnit: "users",
            },
            {
              fieldName: "numUsersOfProductOnFirstDay",
              displayName:
                "No. of users who used your product on the first day",
              displayUnit: "users",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "CHURN RATE",
            },
            {
              fieldName: "numLostCust",
              displayName: "No. of customers lost",
              displayUnit: "customers",
            },
            {
              fieldName: "numCustAtStart",
              displayName: "No. of customers at the start",
              displayUnit: "customers",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "TRAFFIC-TO-LEAD RATIO",
            },
            {
              fieldName: "numWebsiteVisitors",
              displayName: "No. of visitors to your website",
              displayUnit: "visitors",
            },
            {
              fieldName: "numLeads",
              displayName: "No. of visitors who are leads",
              displayUnit: "visitors",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "ORDER FULFILLMENT RATE",
            },
            {
              fieldName: "numOrdersProcessed",
              displayName: "No. of processed orders",
              displayUnit: "orders",
            },
            {
              fieldName: "totalNumOrdersReceived",
              displayName: "Total no. of orders received",
              displayUnit: "orders",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "EMPLOYEE SATISFACTION RATING",
            },
            {
              fieldName: "employeeSatisfactionRating",
              displayName: "Employee satisfaction rating",
              renderContent: !data["employeeSatisfactionRating"]
                ? "-"
                : data["employeeSatisfactionRating"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "CUSTOMER RETENTION RATE",
            },
            {
              fieldName: "custRetentionRate",
              displayName:
                "No. of customers a company retains over a given period of time",
              displayUnit: "customers",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "MONTHLY RECURRING REVENUE (MRR)",
            },
            {
              fieldName: "totalNumPayingusers",
              displayName: "Total no. of paying users",
              displayUnit: "users",
            },
            {
              fieldName: "avRevenuePerUser",
              displayName: "Average revenue per user (ARPU)",
              renderContent: !data["avRevenuePerUser"]
                ? "-"
                : "USD" + data["avRevenuePerUser"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "NET MRR GROWTH RATE",
            },
            {
              fieldName: "netMRRPreviousMonth",
              displayName: "Net MRR of the previous month",
              renderContent: !data["netMRRPreviousMonth"]
                ? "-"
                : "USD" + data["netMRRPreviousMonth"],
            },
            {
              fieldName: "netMRRCurrentMonth",
              displayName: "Net MRR of the current month",
              renderContent: !data["netMRRCurrentMonth"]
                ? "-"
                : "USD" + data["netMRRCurrentMonth"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "NET MRR CHURN RATE",
            },
            {
              fieldName: "contractionMRR",
              displayName:
                "Total reduction in MRR due to downgrades and subscription cancellations (or churn) compared to the previous month (contraction MRR)",
              renderContent: !data["contractionMRR"]
                ? "-"
                : "USD" + data["contractionMRR"],
            },
            {
              fieldName: "expansionMRR",
              displayName:
                "Additional MRR generated in the current month compared to the previous month, excluding the MRR contributed by new customers/new MRR",
              renderContent: !data["expansionMRR"]
                ? "-"
                : "USD" + data["expansionMRR"],
            },
            {
              fieldName: "MRRAtStart",
              displayName: "MRR at the start",
              renderContent: !data["MRRAtStart"]
                ? "-"
                : "USD" + data["MRRAtStart"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "GROSS MRR CHURN RATE",
            },
            {
              fieldName: "totalMRRChurnThisMonth",
              displayName: "Total MRR churn in the current month",
              renderContent: !data["totalMRRChurnThisMonth"]
                ? "-"
                : "USD" + data["totalMRRChurnThisMonth"],
            },
            {
              fieldName: "totalMRRAtStartThisMonth",
              displayName: "Total MRR at the start of the current month",
              renderContent: !data["totalMRRAtStartThisMonth"]
                ? "-"
                : "USD" + data["totalMRRAtStartThisMonth"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "EMPLOYEES",
            },
            {
              fieldName: "numEmployees",
              displayName: "No. of employees in your company/organization",
              displayUnit: "employee(s)",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "FUNDING",
            },
            {
              fieldName: "fundingValue",
              displayName: "Funding value",
              unitName: "fundingUnit",
              renderContent:
                !data["fieldName"] && !data["fundingUnit"]
                  ? "-"
                  : "USD" + data["fundingValue"] + " " + data["fundingUnit"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "ANNUAL RECURRING REVENUE (ARR)",
            },
            {
              fieldName: "ARRValue",
              displayName:
                "Subscription economy metric that shows the money that comes in every year for the life of a subscription/contract",
              unitName: "ARRUnit",
              renderContent:
                !data["ARRValue"] && !data["ARRUnit"]
                  ? "-"
                  : "USD" + data["ARRValue"] + " " + data["ARRUnit"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "SALES & MARKETING SPEND",
            },
            {
              fieldName: "salesAndMarketingSpend",
              displayName:
                "Total internal and external expenses incurred that are directly and indirectly related to selling and marketing your product/service",
              renderContent: !data["salesAndMarketingSpend"]
                ? "-"
                : "USD" + data["salesAndMarketingSpend"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "RESEARCH & DEVELOPMENT SPEND",
            },
            {
              fieldName: "researchAndDevSpend",
              displayName: "Basic measure that covers intramural expenditure",
              renderContent: !data["researchAndDevSpend"]
                ? "-"
                : "USD" + data["researchAndDevSpend"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "CAC PAYBACK PERIOD",
            },
            {
              fieldName: "cacPaybackPeriodInMonths",
              displayName: "Time taken for your company to earn back your CAC",
              displayUnit: "months",
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "GROSS DOLLAR RETENTION",
            },
            {
              fieldName: "grossDollarRetention",
              displayName:
                "Amount of recurring revenue retained from existing customers in a defined time period, including downgrades and cancellations, excluding any expansion revenue",
              renderContent: !data["grossDollarRetention"]
                ? "-"
                : "USD" + data["grossDollarRetention"],
            },
            {
              type: "rowBreak",
            },
            {
              type: "bodyHeaderCenter",
              displayName: "NET DOLLAR RETENTION",
            },
            {
              fieldName: "netDollarRetention",
              displayName:
                "Amount of ARR/MRR which has grown or shrunk over time by factoring in customer expansion as well as negative churn and downgrades",
              renderContent: !data["netDollarRetention"]
                ? "-"
                : "USD" + data["netDollarRetention"],
            },
          ]}
        />
      </AccordianCard>
    </PitchDeckContentLayout>
  );
}

export default ViewOperations;
